import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import "./style.module.scss";
import ContainerHeader from "../ContainerHeader";
export default function ObjectContainer(props) {
    const { className, title, rumIcon, synIcon, description, dropdownConfig, inlineHelp, children } = props;
    const header = title || description || dropdownConfig ? (_jsx(ContainerHeader, { title: title, rumIcon: rumIcon, synIcon: synIcon, description: description, dropdownConfig: dropdownConfig, inlineHelp: inlineHelp })) : (props.header);
    return (_jsxs("div", { className: classNames("object-container", className), children: [header, _jsx("div", { className: "object-container__content", children: children })] }));
}
